import { BlueEnvironment as ImportedBlueEnvironment } from "@packages/config";
import type { Config } from "../config.contract";

export class BlueEnvironment
  extends ImportedBlueEnvironment
  implements Config
{
  // Favorites usa a mesma propriedade Adobe Launch da garagem (dd5a99595f9f),
  // distinta da propriedade padrão do next.ui (home/search).
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/dd5a99595f9f/launch-f0d9f98674fe-staging.min.js";
  enableDatadog = true;
}
